import { render, staticRenderFns } from "./IconCalendarCheckLight.vue?vue&type=template&id=ecd99e1e&"
import script from "./IconCalendarCheckLight.vue?vue&type=script&lang=js&"
export * from "./IconCalendarCheckLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports